import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  alertApiRef,
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { toastApiRef, ToastApiMessage } from '@backstage/frontend-plugin-api';
import {
  PortalImageClient,
  portalImageApiRef,
} from './apis/portalImageApi';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  // The new frontend system provides core.toast out of the box, but this app
  // still uses the legacy createApp, which has no ToastApi implementation.
  // plugin-notifications >=0.5.16 requires it, so forward toasts to AlertApi.
  createApiFactory({
    api: toastApiRef,
    deps: { alertApi: alertApiRef },
    factory: ({ alertApi }) => ({
      post(toast: ToastApiMessage) {
        const severityMap = {
          success: 'success',
          danger: 'error',
          warning: 'warning',
          info: 'info',
          neutral: 'info',
        } as const;
        alertApi.post({
          message:
            typeof toast.title === 'string'
              ? toast.title
              : 'Notification received',
          severity: severityMap[toast.status ?? 'success'],
          display: toast.timeout === undefined ? 'permanent' : 'transient',
        });
        return { close: () => {} };
      },
    }),
  }),
  createApiFactory({
    api: portalImageApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
      identityApi: identityApiRef,
    },
    factory: ({ discoveryApi, fetchApi, identityApi }) =>
      new PortalImageClient(discoveryApi, fetchApi, identityApi),
  }),
];
